export const dataColors = {
  // V1
  primary: "var(--color-background-brand)",
  benchmark: "var(--color-background-brand-tertiary)",
  green: "var(--color-green-500)",
  /** Matches the reach bar of `MeterChart`. */
  success: "var(--color-background-success)",
  grid: "var(--color-background-secondary)",
  axis: "var(--color-border-default)",
  orange: "#ff9500",
  mint: "#00c7be",
  purple: "#af52de",
  label: "var(--color-text-primary)",
  pieChartGrey: "var(--color-background-secondary)",
  pieChartDarkGrey: "var(--color-background-tertiary)",
  pieChartDark: "var(--color-background-brand-dark)",
} as const;
